import { render, staticRenderFns } from "./UserAPIToken.vue?vue&type=template&id=e3997096&scoped=true&"
import script from "./UserAPIToken.vue?vue&type=script&lang=js&"
export * from "./UserAPIToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3997096",
  null
  
)

export default component.exports